import React from "react";
import { Stack } from "@mui/material";
export default function TopNavigator({ children, mb = 2 }) {
  return (
    <Stack
      mb={mb}
      direction={"row"}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {children}
    </Stack>
  );
}
